export const SETCATEGORYSAVE = "SETCATEGORYSAVE";
export const SETPOLICY = "SETPOLICY";
export const SETACCOUNT = "SETACCOUNT";
export const SAVECATEGORYITEM = "SAVECATEGORYITEM";
export const SAVEMILEAGEITEM = "SAVEMILEAGEITEM";
export const SAVEPERDIEMITEM = "SAVEPERDIEMITEM";
export const SAVETRIPITEM = "SAVETRIPITEM";
export const SAVEPOLICYITEM = "SAVEPOLICYITEM";
export const SETPOLICYLIST = "SETPOLICYLIST";
export const CLEARDOC = "CLEARDOC";







